const PREFIX = 'THINGS';

export const LIST_THINGS = `${PREFIX}/LIST`;
export const RETRIEVE_THING = `${PREFIX}/RETRIEVE`;
export const ALL_THINGS = `${PREFIX}/ALL`;
export const CREATE_THING = `${PREFIX}/CREATE`;
export const UPDATE_THING = `${PREFIX}/UPDATE`;
export const DELETE_THING = `${PREFIX}/DELETE`;
export const SET_FILTER_THING = `${PREFIX}/SET_FILTER`;
